<template>
  <div>
    <vxe-grid
      ref="table"
      border
      resizable
      auto-resize
      highlight-hover-row
      show-overflow
      show-header-overflow
      size="mini"
      class="result-table"
      :columns="tableColumns"
      :data="data"
      :loading="loading"
      :height="height"
      :toolbar-config="{ zoom: true, slots: { buttons: 'toolbar_form' } }"
      :row-class-name="rowClassName"
      :cell-class-name="cellClassName"
      @zoom="tableZoom"
    >
      <template #toolbar_form>
        <slot name="toolbar_form"></slot>
      </template>
      <template v-slot:defaultValue="e">
        {{ defaultValue(e) }}
      </template>
      <template v-slot:diff-type="{ row }">
        <el-tag v-if="row.added" size="mini">新增</el-tag>
        <el-tag v-if="row.changed" size="mini" type="success">有更新</el-tag>
        <el-tag v-if="row.removed" size="mini" type="danger">已删除</el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="$emit('openDetail', row)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ '无差异数据' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
const XlsxPopulate = require('xlsx-populate')
export default {
  props: {
    columns: { type: Array, default: () => [] },
    data: { type: Array, default: () => [] },
    height: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
  },
  computed: {
    tableColumns() {
      if (!this.columns || !this.columns.length) return []
      const _columns = this.columns.map(({ label, field }) => ({
        title: label,
        field,
        minWidth: 140,
        align: 'left',
        headerAlign: 'center',
        showHeaderOverflow: true,
        showOverflow: true,
        slots: { default: 'defaultValue' },
      }))
      _columns.unshift(
        ...[
          {
            field: 'seq',
            width: 50,
            align: 'center',
            fixed: 'left',
            type: 'seq',
          },
          {
            field: 'col-opt',
            title: this.$l('INDEX.table_label_operation') || '操作',
            headerAlign: 'center',
            align: 'center',
            fixed: 'right',
            width: 90,
            slots: { default: 'opt' },
          },
          {
            title: '差异结果',
            width: 100,
            align: 'center',
            fixed: 'left',
            slots: { default: 'diff-type' },
          },
          {
            title: '差异说明',
            minWidth: 220,
            headerAlign: 'center',
            align: 'left',
            fixed: 'left',
            formatter: ({ row }) => {
              const { added, removed, changed, originIndex, currentIndex } = row
              if (changed)
                return `原始文件第【${originIndex + 2}】行数据，有更新`
              if (added)
                return `更新文件第【${currentIndex + 2}】行，是新增记录`
              if (removed)
                return `原始文件第【${originIndex + 2}】行数据，被删除`
            },
          },
        ]
      )
      return _columns
    },
    changeLog() {
      if (!this.data || !this.data.length) return ''
      const changedCount = this.data.filter((item) => item.changed).length
      const removedCount = this.data.filter((item) => item.removed).length
      const addedCount = this.data.filter((item) => item.added).length
      return [
        !changedCount ? null : `【${changedCount}】条更新`,
        !removedCount ? null : `【${removedCount}】条删除`,
        !addedCount ? null : `【${addedCount}】条新增`,
      ]
        .filter(Boolean)
        .join('，')
    },
  },
  methods: {
    rowClassName({ row }) {
      const { added, removed, changed } = row
      if (added) return 'added'
      if (removed) return 'removed'
      if (changed) return 'changed'
    },
    cellClassName({ row, column }) {
      const { property } = column
      const { modifyCols, changed } = row
      if (!changed) return
      const current = modifyCols[property]
      if (current == undefined || current == null) return
      if (current === '') return 'changed clear'
      return 'changed'
    },
    tableZoom({ type }) {
      const $table = this.$refs.table
      if (type == 'max') $table.hideColumn('col-opt')
      else $table.showColumn('col-opt')
    },
    defaultValue({ row, column }) {
      const { property } = column
      const { modifyCols, changed } = row
      const value = row[property]
      const modify = (modifyCols || {})[property]
      if (!changed) return value
      if (changed) return value || modify
    },
    async exportResult() {
      if (!this.data || !this.data.length) {
        this.$message.error('无比对结果，无法生成Excel')
        return
      }

      const columnLabels = this.columns.map(({ label }) => label)
      columnLabels.unshift(...['差异结果', '差异说明'])

      const RichText = XlsxPopulate.RichText
      const columnValues = this.data.map((row) => {
        const {
          added,
          removed,
          changed,
          originIndex,
          currentIndex,
          modifyCols,
        } = row

        const col_1_added_styles = { fontColor: '409EFF', bold: true }
        const col_1_changed_styles = { fontColor: '67c23a', bold: true }
        const col_1_removed_styles = { fontColor: 'f56c6c', bold: true }

        const col_1 = new RichText()
        col_1.add(
          added ? '新增' : changed ? '有更新' : removed ? '已删除' : '',
          added
            ? col_1_added_styles
            : changed
            ? col_1_changed_styles
            : removed
            ? col_1_removed_styles
            : {}
        )

        const col_2 = new RichText()
        if (changed) col_2.add(`原始文件第【${originIndex + 2}】行数据，有更新`)
        if (added) col_2.add(`更新文件第【${currentIndex + 2}】行，是新增记录`)
        if (removed) col_2.add(`原始文件第【${originIndex + 2}】行数据，被删除`)
        const values = this.columns.map(({ field }) => {
          const modify = (modifyCols || {})[field]
          const col = new RichText()
          const colValue = changed ? row[field] || modify : row[field]
          col.add(colValue == undefined ? '' : colValue, {
            bold: modify !== undefined && modify !== null,
            strikethrough: modify === '',
            fontColor:
              (row[field] == undefined ||
                row[field] == null ||
                row[field] == '') &&
              (modify !== undefined || modify !== null)
                ? '409EFF'
                : row[field] !== '' &&
                  modify !== undefined &&
                  modify !== null &&
                  modify !== ''
                ? '67c23a'
                : '',
          })
          return col
        })
        values.unshift(...[col_1, col_2])
        return values
      })

      const workbook = await XlsxPopulate.fromBlankAsync()
      const sheet = workbook.sheet(0)

      sheet.cell('A1').value([columnLabels, ...columnValues])

      const range = sheet.usedRange()
      range.style({ border: true })

      const cells = range.cells()
      cells.forEach((r, i) => {
        sheet
          .row(i + 1)
          .height(22)
          .style({ verticalAlignment: 'center' })

        r.forEach((c) => {
          const cv = c.value()
          if (cv instanceof RichText) {
            const cvf = cv.get(0)
            if (cvf && cvf.style('strikethrough')) {
              c.style({ fill: 'fbe9eb' })
            }
          }
        })
      })

      cells[0].forEach((c, i) => {
        c.style({ fill: 'e8eaec' })
        sheet.column(i + 1).width(14)
      })
      sheet
        .column(1)
        .width(10)
        .style({ horizontalAlignment: 'center' })
      sheet.column(2).width(30)
      sheet
        .row(1)
        .height(25)
        .style({
          bold: true,
          horizontalAlignment: 'center',
          verticalAlignment: 'center',
        })

      const blob = await workbook.outputAsync()
      this.$refs.table.saveFile({
        filename: `比对差异结果_${new Date().getTime()}`,
        type: 'xlsx',
        content: blob,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
div[class^='side-frame'] {
  margin: 0;
  padding-right: 0;
  display: inline-block;
  font-size: 14px;
  color: #606266;
}
::v-deep {
  .result-table {
    .vxe-body--row.changed {
      .vxe-body--column.changed {
        font-weight: bold;
        color: #000000;
      }
      .vxe-body--column.clear {
        background-color: #fbe9eb;
        text-decoration: line-through;
      }
    }
  }
}
</style>
